import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import script from './ImageRenderer.vue_rollup-plugin-vue=script.js';

/* script */
const __vue_script__ = script;
/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "image-container", attrs: { loading: _vm.isLoading } },
    [
      _vm.url
        ? _c("img", {
            staticClass: "image",
            attrs: {
              src: _vm.url,
              alt: "attached image",
              height: _vm.height,
              width: _vm.width
            }
          })
        : _c("div", {
            staticClass: "placeholder",
            style: {
              width: _vm.placeholderSize + "px",
              height: _vm.placeholderSize + "px"
            }
          }),
      _vm._v(" "),
      _vm.showActions && (_vm.url || _vm.$slots.actions)
        ? _c(
            "div",
            { staticClass: "actions" },
            [
              _vm.url && _vm.zoomable
                ? _c(
                    "a",
                    { attrs: { href: _vm.url, target: "_blank" } },
                    [
                      _c(
                        "Button",
                        {
                          staticClass: "action-button",
                          attrs: { appearance: "subtle" }
                        },
                        [_c("SearchIcon")],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm._t("actions")
            ],
            2
          )
        : _vm._e()
    ]
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = "data-v-0ba71f1e";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/field-renderers/ImageRenderer.vue.js